module.exports = __webpack_public_path__ + "img/bus-front-outline-grey.58b76996.svg";